import { MessageReduxType } from "../constant/Types";

export const addBulkMessage = (messages = []) => {
  return {
    type: MessageReduxType.addBulk,
    data: messages,
  };
};

export const setMessagesLoading = (status) => {
  return {
    type: MessageReduxType.loading,
    data: status,
  };
};
